import { SVGProps } from 'react';

const PhoneIcon: React.FC<SVGProps<SVGSVGElement>> = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="25"
    height="24"
    viewBox="0 0 25 24"
    fill="none"
    {...props}
  >
    <path
      d="M4.08579 3.58579C3.71071 3.96086 3.5 4.46957 3.5 5V6C3.5 14.284 10.216 21 18.5 21H19.5C20.0304 21 20.5391 20.7893 20.9142 20.4142C21.2893 20.0391 21.5 19.5304 21.5 19V15.721C21.5001 15.511 21.434 15.3064 21.3112 15.136C21.1885 14.9657 21.0152 14.8383 20.816 14.772L16.323 13.274C16.0947 13.1981 15.8466 13.2071 15.6244 13.2993C15.4021 13.3915 15.2205 13.5607 15.113 13.776L13.983 16.033C11.5345 14.9267 9.57332 12.9655 8.467 10.517L10.724 9.387C10.9393 9.27945 11.1085 9.0979 11.2007 8.87564C11.2929 8.65339 11.3019 8.40534 11.226 8.177L9.728 3.684C9.66171 3.48496 9.53449 3.3118 9.36436 3.18905C9.19422 3.0663 8.98979 3.00016 8.78 3H5.5C4.96957 3 4.46086 3.21071 4.08579 3.58579Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default PhoneIcon;
